import { useCallback, useEffect, useState } from "react";
import { getDocSetting, setDocSetting } from "../lib/storage";

const KEY = "pontifexx_chat_id";

export function useDocumentThread() {
  const [chatId, setChatIdState] = useState<string | null>(null);

  useEffect(() => {
    setChatIdState(getDocSetting<string>(KEY));
  }, []);

  const setChatId = useCallback(async (id: string | null) => {
    setChatIdState(id);
    await setDocSetting(KEY, id);
  }, []);

  return { chatId, setChatId };
}
